import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "toggle", "hint"]
  static values = {
    validations: Array,
  }
  declare inputTarget: HTMLInputElement
  declare toggleTarget: HTMLElement
  declare hintTarget: HTMLElement
  declare validationsValue: Array<{ key: string, regex: string, message: string }>
  private onInput = () => this.validatePassword()
  private initialHintHTML = ""
  // static debounces = [
  //   {
  //     name: 'checkPassword',
  //     wait: 100
  //   }
  // ]

  connect() {
    if (!(this.toggleTarget instanceof HTMLElement)) return
    if (!(this.inputTarget instanceof HTMLInputElement)) return

    this.initialHintHTML = this.hintTarget.innerHTML
    this.toggleTarget.addEventListener("mousedown", (event) => this.togglePasswordMask(event, this.inputTarget, this.toggleTarget))
    this.inputTarget.addEventListener("input", this.onInput)
    // Browsers can restore/autofill a value before connect(), so render once up front.
    this.validatePassword()
  }
  disconnect() {
    if (!(this.inputTarget instanceof HTMLInputElement)) return

    this.inputTarget.removeEventListener("input", this.onInput)
  }
  // Ruby serialises a Regexp as "(?-mix:[A-Z])" – unwrap it back to the bare source.
  private toRegExp(source: string) {
    const match = source.match(/^\(\?[a-zA-Z-]*:(.*)\)$/s)
    return RegExp(match ? match[1] : source)
  }
  resetHint() {
    this.hintTarget.classList.remove("tw-form__hint--plain")
    this.hintTarget.innerHTML = this.initialHintHTML
    this.hintTarget.style.display = "none"
  }
  validatePassword() {
    let validations = this.validationsValue
    let password = this.inputTarget.value
    if (!password) {
      this.resetHint()
      return
    }
    let validResults = validations.map(validation => {
      return {
        key: validation.key,
        valid: this.toRegExp(validation.regex).test(password),
        message: validation.message
      }
    })
    this.hintTarget.style.display = ""
    this.hintTarget.textContent = ""
    this.hintTarget.classList.add("tw-form__hint--plain")
    const intro = document.createElement("span")
    intro.textContent = "Passwort sollte beinhalten:"
    this.hintTarget.append(intro)
    const ul = document.createElement("ul")
    validResults.forEach(v => {
      const li = document.createElement("li")
      li.className = v.valid ? "tw-form__rule tw-form__rule--ok" : "tw-form__rule tw-form__rule--todo"
      li.textContent = v.message
      ul.append(li)
    })
    this.hintTarget.append(ul)
  }
  togglePasswordMask(event: Event, input: HTMLInputElement, toggle: HTMLElement) {
    event.preventDefault()
    if (!(input instanceof HTMLInputElement)) return
    if (!(toggle instanceof HTMLElement)) return

    let icon: HTMLElement | null = toggle.querySelector("i");
    if (!(icon instanceof HTMLElement)) return

    icon.classList.toggle("fa-eye");
    icon.classList.toggle("fa-eye-slash");
    if (input.getAttribute("type") === "password") {
      input.setAttribute("type", "text");
    } else {
      input.setAttribute("type", "password");
    }
    const isVisible = input.getAttribute("type") === "text"
    toggle.setAttribute("aria-pressed", String(isVisible))
    toggle.setAttribute("aria-label", isVisible ? "Passwort verbergen" : "Passwort anzeigen")
  }
}
